import Wrapper from "../assets/wrappers/CustomTooltip";

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        const commentName = payload[0].dataKey + "Comment"
        const value = payload[0].value.toString().replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        if (payload[0].payload[commentName]) {
            return (
                <Wrapper>
                    <p className="label">{label}</p>
                    <p className="intro" style={{ color: payload[0].color }}>{`${payload[0].name}: ${value}`}</p>
                    <p className="desc">{payload[0].payload[commentName]}</p>
                </Wrapper>
            );
        } else {
            return (
                <Wrapper>
                    <p className="label">{label}</p>
                    <p className="intro" style={{ color: payload[0].color }}>{`${payload[0].name}: ${value}`}</p>
                </Wrapper>
            );
        }

    }

    return null;
}

export default CustomTooltip